import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faUser, faLock, faSignOutAlt, faCog, faPen, faEye, faBell
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub, faFacebookF, faTwitter, faGoogle, faInstagram
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUser, faLock, faSignOutAlt, faCog, faGithub, faFacebookF, faTwitter, faGoogle, faInstagram, faPen, faEye, faBell
)

Vue.component('fa', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./src/plugins/fontawesome.js